/* eslint-disable no-empty */
/* eslint-disable no-console */

import atob from 'atob';

import { DesignSysEnvUtil } from './design-sys-env-util';

const getCookieName = () => {
  const name = DesignSysEnvUtil.userCookieName;
  if (!name) {
    throw new Error(
      'JWT_COOKIE_KEY is not configured. Every environment must set this value (e.g. user, user_stage, user_local).'
    );
  }
  return name;
};

const CookieHandler = {
  getAll() {
    let str;
    try {
      str = document.cookie;
    } catch (err) {
      if (
        typeof console !== 'undefined' &&
        // Super old code that needs a refactor

        typeof console.error === 'function'
      ) {
        // Super old code that needs a refactor

        console.error(err.stack || err);
      }
      return {};
    }
    return CookieHandler.parse(str);
  },
  parse(str) {
    const obj = {};
    const pairs = str.split(/ *; */);
    let pair;
    if (pairs[0] === '') return obj;
    for (const pair_ of pairs) {
      pair = pair_.split('=');
      obj[CookieHandler.decode(pair[0])] = CookieHandler.decode(pair[1]);
    }
    return obj;
  },
  encode(value) {
    try {
      return encodeURIComponent(value);
    } catch {
      // debug('error `encode(%o)` - %o', value, e)
    }

    return null;
  },
  decode(value) {
    try {
      return decodeURIComponent(value);
    } catch {
      // debug('error `decode(%o)` - %o', value, e)
    }

    return null;
  },
  decodeJWT(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');

      return JSON.parse(atob(base64));
    } catch {
      return null;
    }
  },
};

export const CookieUtil = {
  set(name, value, options) {
    options = options || {};
    let str = `${CookieHandler.encode(name)}=${CookieHandler.encode(value)}`;

    if (value == null) options.maxage = -1;

    if (options.maxage) {
      options.expires = new Date(Date.now() + options.maxage);
    }

    if (options.path) str += `; path=${options.path}`;
    if (options.domain) str += `; domain=${options.domain}`;
    if (options.expires) str += `; expires=${options.expires.toUTCString()}`;
    if (options.secure) str += '; secure';
    str += `; SameSite=${options.SameSite || 'Lax'}`;

    // eslint-disable-next-line unicorn/no-document-cookie
    document.cookie = str;
  },
  get(name) {
    return CookieHandler.getAll()[name];
  },
  getUserCookieName() {
    return getCookieName();
  },
  getUserToken() {
    return CookieUtil.get(getCookieName());
  },
  hasUserCookie() {
    return !!CookieUtil.getUserToken();
  },
  decodeJWT(token) {
    return CookieHandler.decodeJWT(token);
  },
  parseCookieHeader(headerString) {
    return CookieHandler.parse(headerString || '');
  },
  getUserExp() {
    const decodedUser = CookieUtil.decodeUserCookie();
    return decodedUser?.exp ?? 0;
  },
  setUserCookie(jwt, { domain, isSafari }) {
    CookieUtil.set(getCookieName(), jwt, {
      domain,
      path: '/',
      SameSite: isSafari ? 'None' : 'Lax',
      secure: isSafari,
    });
  },
  isUserExpired(token = null) {
    const decodedUser = token || CookieUtil.decodeUserCookie();

    if (!decodedUser) {
      return true;
    }

    // The encoded expiration time is in seconds
    const nowSeconds = Date.now() / 1000;
    return !(decodedUser.exp - nowSeconds > 0);
  },
  decodeUserCookie() {
    try {
      const cookies = CookieHandler.parse(document.cookie);
      return CookieHandler.decodeJWT(cookies[getCookieName()]);
    } catch {
      return null;
    }
  },
  clearUser(domain) {
    const name = getCookieName();

    /**
     * Legacy migration: also clear the historical literal `user` cookie
     * on known legacy domains so users carrying old cookies are forced
     * to re-auth cleanly. Safe to remove after all envs have rolled.
     */
    for (const legacyDomain of [
      '.apps.axiomlaw.com',
      '.stage.axiomlaw.com',
      '.apps.axiomlaw.dev',
      domain,
    ]) {
      try {
        CookieUtil.set('user', null, { domain: legacyDomain, path: '/' });
      } catch {}
    }

    CookieUtil.set(name, null, {
      domain,
      path: '/',
    });
  },
  clearUserAndReload(domain) {
    CookieUtil.clearUser(domain);
    window.location.reload();
  },
};
